import React from 'react'
import { CartesianGrid, Line, LineChart, XAxis, LabelList } from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'

const Chart = ({ data, title, xDataKey, yDataKey, cardClassName }) => {
  return (
    <Card
      className={
        cardClassName ?? 'w-[500px] mt-2 me-2'
      }
    >
      <CardHeader className={cardClassName ? 'pb-2' : undefined}>
        <CardTitle className={cardClassName ? 'text-base' : undefined}>
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className={cardClassName ? 'min-h-0 flex-1 pt-0' : undefined}>
        <ChartContainer
          config={{
            desktop: {
              label: yDataKey,
              color: '#555',
            },
          }}
        >
          <LineChart
            accessibilityLayer
            data={data}
            margin={{
              top: 20,
              left: 12,
              right: 12,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey={xDataKey}
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={(value) => value.slice(8)}
            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent indicator="line" />}
            />
            <Line
              dataKey={yDataKey}
              type="natural"
              stroke="#ff3e76"
              strokeWidth={2}
              tickLine={false}
              axisLine={false}
              tickMargin={8}
            >
              <LabelList
                position="top"
                offset={12}
                className="fill-foreground"
                fontSize={12}
              />
            </Line>
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}

export default Chart
